import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar,
  IonBackButton,
  IonButtons,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
  IonButton,
  IonRouterContext,
  IonRouteProps,
  IonLoading,
  IonToast,
  IonFab,
  IonFabButton,
  IonPopover,
  IonList,
  IonSegment,
  IonSegmentButton
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ticketOutline, ellipsisVerticalOutline, cubeOutline, albumsOutline } from 'ionicons/icons';
import './Backup.css';
import { getCashRegister, getDominio, getLoginApp, getToken, getchek } from '../../utils/functions';
import { API } from '../../constants/system';
import { baseurl } from '../../constants/constants';
import BackupActions from '../../actions/BackupActions';

import {
  initdb,
  queryAllLocations,
  createLocationTest,
  queryAllPermisions,
  queryAllConfiguration,
  queryAllActivities,
  queryAllProductsOffline,
  replaceAllProductsOffline,
  queryAllCustomersOffline,
  replaceAllCustomersOffline,
} from "../../data_base_local/dataservice";

interface IProps {
  setData: any;
  get_: any;
}

interface IState {
  loading: any;
  segmentActive: any;
  dataLocations: any;
  dataConfigurations: any;
  dataPermissions: any;
  dataActivities: any;
  dataProducts: any;
  dataCustomers: any;
  syncProductsError: any;
  syncProductsResponse: any;
  syncProductsStatus: any;
  syncCustomersError: any;
  syncCustomersResponse: any;
  syncCustomersStatus: any;
  API: any;
}

class Backup extends React.Component<IProps, IState> {
  contentRef: React.RefObject<HTMLIonContentElement>;
  popover: React.RefObject<HTMLIonPopoverElement>;

  constructor(props: any) {
    super(props)

    this.popover = React.createRef<HTMLIonPopoverElement>();
    this.contentRef = React.createRef<HTMLIonContentElement>();

    this.state = {
      loading: props.loading,
      segmentActive: props.segmentActive,
      dataLocations: props.dataLocations,
      dataConfigurations: props.dataConfigurations,
      dataPermissions: props.dataPermissions,
      dataActivities: props.dataActivities,
      dataProducts: props.dataProducts,
      dataCustomers: props.dataCustomers,
      syncProductsError: '',
      syncProductsResponse: '',
      syncProductsStatus: '',
      syncCustomersError: '',
      syncCustomersResponse: '',
      syncCustomersStatus: '',
      API: API
    }

  }

  async GetAllLocations() {
    let data = await queryAllLocations().then();
    return data.values;
  };

  async SetLocation() {
    await createLocationTest().then();
  };

  async GetAllPermisions() {
    let data = await queryAllPermisions().then();
    return data.values;
  };

  async GetAllConfiguration() {
    let data = await queryAllConfiguration().then();
    return data.values;
  };

  async GetAllActivities() {
    let data = await queryAllActivities().then();
    return data.values;
  };

  async GetAllProducts() {
    let data = await queryAllProductsOffline().then();
    return data.values;
  };

  async GetAllCustomers() {
    let data = await queryAllCustomersOffline().then();
    return data.values;
  };

  UNSAFE_componentWillReceiveProps(nextProps: any) {

  }

  async componentDidMount() {
    await initdb();
    let dataProducts = await this.GetAllProducts();
    let dataCustomers = await this.GetAllCustomers();

    this.setState({
      loading: false,
      segmentActive: "locations",
      dataLocations: [],
      dataConfigurations: [],
      dataPermissions: [],
      dataActivities: [],
      dataProducts,
      dataCustomers,
      syncProductsError: '',
      syncProductsResponse: '',
      syncProductsStatus: '',
      syncCustomersError: '',
      syncCustomersResponse: '',
      syncCustomersStatus: ''
    });
  }

  async btnGetPositions() {
    let dataLocations = await this.GetAllLocations();
    this.setState({ dataLocations });
  }

  async btnGetActivities() {
    let dataActivities = await this.GetAllActivities();
    this.setState({ dataActivities });
  }

  async btnSetPositionTest() {
    this.SetLocation();
    this.btnGetPositions();
  }

  async btnGetPermisions() {
    let dataPermissions = await this.GetAllPermisions();
    this.setState({ dataPermissions });
  }

  async btnGetConfiguration() {
    let dataConfigurations = await this.GetAllConfiguration();
    this.setState({ dataConfigurations });
  }

  async btnGetProducts() {
    let dataProducts = await this.GetAllProducts();
    this.setState({ dataProducts });
  }

  async btnGetCustomers() {
    let dataCustomers = await this.GetAllCustomers();
    this.setState({ dataCustomers });
  }

  clearSyncProductsDebug() {
    this.setState({
      syncProductsError: '',
      syncProductsResponse: '',
      syncProductsStatus: ''
    });
  }

  clearSyncCustomersDebug() {
    this.setState({
      syncCustomersError: '',
      syncCustomersResponse: '',
      syncCustomersStatus: ''
    });
  }

  async btnSyncProducts() {
    this.setState({ loading: true, syncProductsError: '', syncProductsResponse: '', syncProductsStatus: '' });

    try {
      const baseUrl = this.getBaseUrl();
      const dataLogin = getLoginApp() || {};
      const cashRegister = getCashRegister() || {};
      const token = getToken();
      const formData = new FormData();

      const locationId = cashRegister.location_id ?? dataLogin.location_id ?? '';
      const priceGroup = dataLogin.selling_price_group_id ?? dataLogin.price_group_id ?? '';

      if (locationId !== '') {
        formData.append('location_id', String(locationId));
      }

      if (priceGroup !== '') {
        formData.append('price_group', String(priceGroup));
      }

      formData.append('check_qty', '0');

      const response = await fetch(baseUrl + '/api/appapk/getProductsOffline', {
        method: 'POST',
        headers: token ? {
          Authorization: 'Bearer ' + token,
        } : undefined,
        body: formData,
      });

      const rawResponse = await response.text();
      let result: any = null;

      try {
        result = rawResponse ? JSON.parse(rawResponse) : null;
      } catch (parseError) {
        result = null;
      }

      this.setState({
        syncProductsResponse: rawResponse || '(respuesta vacia)',
        syncProductsStatus: response.status,
      });

      if (!response.ok || !result || !result.success) {
        const backendMessage = result?.msg || result?.message || rawResponse || 'No se pudieron obtener los productos';
        throw new Error('HTTP ' + response.status + ' - ' + backendMessage);
      }

      await replaceAllProductsOffline(result.data || []);
      let dataProducts = await this.GetAllProducts();
      this.setState({ dataProducts, syncProductsError: '' });
      window.alert('Productos actualizados: ' + dataProducts.length);
    } catch (error: any) {
      const errorMessage = (error?.message || 'desconocido');
      console.log('Error al sincronizar productos', error);
      this.setState({ syncProductsError: errorMessage });
      window.alert('Error al sincronizar productos: ' + errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  }

  async btnSyncCustomers() {
    this.setState({ loading: true, syncCustomersError: '', syncCustomersResponse: '', syncCustomersStatus: '' });

    try {
      const baseUrl = this.getBaseUrl();
      const token = getToken();
      const formData = new FormData();

      const response = await fetch(baseUrl + '/api/appapk/getCustomersOffline', {
        method: 'POST',
        headers: token ? {
          Authorization: 'Bearer ' + token,
        } : undefined,
        body: formData,
      });

      const rawResponse = await response.text();
      let result: any = null;

      try {
        result = rawResponse ? JSON.parse(rawResponse) : null;
      } catch (parseError) {
        result = null;
      }

      this.setState({
        syncCustomersResponse: rawResponse || '(respuesta vacia)',
        syncCustomersStatus: response.status,
      });

      if (!response.ok || !result || !result.success) {
        const backendMessage = result?.msg || result?.message || rawResponse || 'No se pudieron obtener los clientes';
        throw new Error('HTTP ' + response.status + ' - ' + backendMessage);
      }

      await replaceAllCustomersOffline(result.data || []);
      let dataCustomers = await this.GetAllCustomers();
      this.setState({ dataCustomers, syncCustomersError: '' });
      window.alert('Clientes actualizados: ' + dataCustomers.length);
    } catch (error: any) {
      const errorMessage = (error?.message || 'desconocido');
      console.log('Error al sincronizar clientes', error);
      this.setState({ syncCustomersError: errorMessage });
      window.alert('Error al sincronizar clientes: ' + errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  }

  getBaseUrl() {
    const dominioRaw = typeof getDominio === 'function' ? getDominio() : '';
    const dominioValue = (dominioRaw ?? '').toString();
    const dominio: string[] = dominioValue.split('http');
    const storedDomain = window.localStorage.getItem('ari_app_dominio') || '';
    let url = "";

    if (!storedDomain) {
      return url;
    }

    if (dominio.length > 1) {
      url = storedDomain;
    } else {
      url = "https://" + storedDomain;
    }

    return url;
  }

  render() {
    const { loading, segmentActive, dataLocations, dataPermissions, dataConfigurations, dataActivities, dataProducts, dataCustomers, syncProductsError, syncProductsResponse, syncProductsStatus, syncCustomersError, syncCustomersResponse, syncCustomersStatus } = this.state;
    const baseUrl = this.getBaseUrl();
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/home" text={""} />
            </IonButtons>
            <IonTitle style={{ fontSize: "15px" }}>LOCAL DATABASE</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonLoading isOpen={loading} message={'Procesando...'} />
        <IonContent fullscreen ref={this.contentRef} scrollEvents={true}>
          {
            <IonToolbar color="primary">
              <IonSegment value={segmentActive} scrollable>
                <IonSegmentButton
                  value="locations"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'locations'
                    });
                  }}
                >
                  <IonLabel>Locaciones</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="permisions"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'permisions'
                    });
                  }}
                >
                  <IonLabel>Permisos</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="configuration"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'configuration'
                    });
                  }}
                >
                  <IonLabel>Configuración</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="activities"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'activities'
                    });
                  }}
                >
                  <IonLabel>Actividades</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="customers"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'customers'
                    });
                  }}
                >
                  <IonLabel>Clientes</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="products"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'products'
                    });
                  }}
                >
                  <IonLabel>Productos</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonToolbar>
          }
          {
            segmentActive == "locations" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetPositions()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>{/*
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnSetPositionTest()}>
                      <strong>Locación Tst</strong>
                    </IonButton>
                  </IonCol>*/}
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Lat</th>
                            <th>Lng</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataLocations.length > 0 && dataLocations.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.lat}</td>
                                <td>{val.lng}</td>
                                <td>{val.datetime}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "permisions" ?
              <>
                <IonRow>
                  <IonCol col-12 size='12' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetPermisions()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>name</th>
                            <th>status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataPermissions && dataPermissions.length > 0 && dataPermissions.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.name}</td>
                                <td>{val.status}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "configuration" ?
              <>
                <IonRow>
                  <IonCol col-12 size='12' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetConfiguration()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>token</th>
                            <th>data_login</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataConfigurations && dataConfigurations.length > 0 && dataConfigurations.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.token}</td>
                                <td>{val.data_login}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "activities" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetActivities()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>{/*
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnSetPositionTest()}>
                      <strong>Locación Tst</strong>
                    </IonButton>
                  </IonCol>*/}
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Log</th>
                            <th>Descripción</th>
                            <th>Usuario</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataActivities.length > 0 && dataActivities.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.log_name}</td>
                                <td>{val.description}</td>
                                <td>{val.user_id}</td>
                                <td>{val.date}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "customers" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetCustomers()}>
                      <strong>Ver locales</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="primary" onClick={() => this.btnSyncCustomers()}>
                      <strong>Traer del servidor</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12'>
                    <IonButton size="small" color="medium" fill="outline" onClick={() => this.clearSyncCustomersDebug()}>
                      <strong>Limpiar respuesta</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12'>
                    <div style={{ padding: '6px 0', fontSize: '12px', color: '#555' }}>
                      Este boton consulta el servidor, descarga los clientes y luego los guarda en SQLite local.
                    </div>

                    {baseUrl + '/api/appapk/getCustomersOffline'}
                  </IonCol>
                  {
                    syncCustomersError ?
                      <IonCol col-12 size='12'>
                        <div style={{ color: '#b00020', padding: '8px 0', fontSize: '12px', wordBreak: 'break-word' }}>
                          Error: {syncCustomersError}
                        </div>
                      </IonCol>
                      : null
                  }

                  {
                    syncCustomersStatus !== '' || syncCustomersResponse ?
                      <IonCol col-12 size='12'>
                        <div style={{ background: '#f5f5f5', border: '1px solid #ddd', padding: '8px', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          <strong>Status:</strong> {String(syncCustomersStatus || '')}
                          {'\n'}
                          <strong>Respuesta server:</strong>
                          {'\n'}
                          {syncCustomersResponse}
                        </div>
                      </IonCol>
                      : null
                  }

                  <IonCol col-12 size='12' >
                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Codigo</th>
                            <th>Nombre</th>
                            <th>Empresa</th>
                            <th>Tipo</th>
                            <th>Grupo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataCustomers && dataCustomers.length > 0 ? dataCustomers.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.contact_id}</td>
                                <td>{val.name}</td>
                                <td>{val.supplier_business_name}</td>
                                <td>{val.type}</td>
                                <td>{val.customer_group_id}</td>
                              </tr>
                            );
                          }) :
                            <tr>
                              <td colSpan={6}>No hay clientes guardados</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "products" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetProducts()}>
                      <strong>Ver locales</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="primary" onClick={() => this.btnSyncProducts()}>
                      <strong>Traer del servidor</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12'>
                    <IonButton size="small" color="medium" fill="outline" onClick={() => this.clearSyncProductsDebug()}>
                      <strong>Limpiar respuesta</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12'>
                    <div style={{ padding: '6px 0', fontSize: '12px', color: '#555' }}>
                      Este boton consulta el servidor, descarga los productos y luego los guarda en SQLite local.
                    </div>

                    {baseUrl + '/api/appapk/getProductsOffline'}
                  </IonCol>
                  {
                    syncProductsError ?
                      <IonCol col-12 size='12'>
                        <div style={{ color: '#b00020', padding: '8px 0', fontSize: '12px', wordBreak: 'break-word' }}>
                          Error: {syncProductsError}
                        </div>
                      </IonCol>
                      : null
                  }

                  {
                    syncProductsStatus !== '' || syncProductsResponse ?
                      <IonCol col-12 size='12'>
                        <div style={{ background: '#f5f5f5', border: '1px solid #ddd', padding: '8px', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                          <strong>Status:</strong> {String(syncProductsStatus || '')}
                          {'\n'}
                          <strong>Respuesta server:</strong>
                          {'\n'}
                          {syncProductsResponse}
                        </div>
                      </IonCol>
                      : null
                  }


                  <IonCol col-12 size='12' >
                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Producto</th>
                            <th>SKU</th>
                            <th>Precio</th>
                            <th>Stock</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataProducts && dataProducts.length > 0 ? dataProducts.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.name}</td>
                                <td>{val.sub_sku}</td>
                                <td>{val.current_price_discount}</td>
                                <td>{val.qty_available}</td>
                              </tr>
                            );
                          }) :
                            <tr>
                              <td colSpan={5}>No hay productos guardados</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    setData: PropTypes.func.isRequired,
    data: state.data,
    _get: PropTypes.func.isRequired,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setData: (item: string) => dispatch(BackupActions.setData(item)),
    get_: (fields: any, controller: string) => dispatch(BackupActions.get_(fields, controller)),

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Backup);
